<div class="toaster-host" data-testid="toaster-host">
  @for (toast of toasts(); track toast.id) {
    <app-toaster
      [status]="toast.status"
      [title]="toast.title"
      [subtitle]="toast.subtitle ?? ''"
      [message]="toast.message ?? ''"
      [action]="toast.action"
      [clickHandler]="toast.onClick"
      [duration]="toast.duration"
      [restartToken]="toast.restartToken"
      (closed)="dismiss(toast.id)"
    >
      @if (toast.component) {
        <ng-container [ngComponentOutlet]="toast.component" [ngComponentOutletInputs]="toast.componentInputs ?? {}" />
      }
    </app-toaster>
  }
</div>
